export const storageKey = {
  enumData: 'enumData',
  instituteEnumData: 'instituteEnumData',
  cityState: 'cityStateData',
  executiveCode: 'executiveCode',
  instituteFormData: 'instituteFormData',
  subscriptionData: 'subscriptionData',
};
